<template>
  <div class="discussion_box" v-if="!showReleasePublic">
    <div class="top_title flex Flexalign FlexBetween">
      <div class="flex Flexalign">
        <div class="cursor_pointer" @click="changeClassify('')">讨论组</div>
        <div class="release_public_text mar_left_10" v-if="listQuery.classify != ''">
          >
          {{
            listQuery.classify == 1
              ? "老师答疑区"
              : listQuery.classify == 2
                ? "课堂交流区"
                : "综合讨论区"
          }}
        </div>
      </div>
      <div class="Flexalign flex use_rule cursor_pointer" @mouseenter="showUseRule" @mouseleave="hideUseRule">
        <div>使用规则</div>
        <el-image class="green_doubt_icon" :src="iconPath('green_doubt_icon.png')"></el-image>
        <div class="use_rule_box" v-if="showUseRuleFlag">
          <div class="use_rule_title">使用规则</div>
          <div v-html="useRule"></div>
        </div>
      </div>
    </div>
    <div class="discussion_welcome mar_top_15">
      欢迎大家来到讨论区！本讨论区供各位同学就课程问题进行交流学习。请同学们认真阅读下面的【讨论区使用规则】，然后再进行相关发表，谢谢
    </div>
    <div class="notice_box mar_top_15 flex Flexalign FlexBetween cursor_pointer" v-if="!$Tools.empty(lastNotice)"
      @click="goNoticeDetail(lastNotice)">
      <div class="flex Flexalign flex-1 toverflow">
        <el-image class="teacher_public" :src="iconPath('teacher_public.png')"></el-image>
        <div class="teacher_public_text flex-1 toverflow">{{ lastNotice.noticeTitle }}</div>
        <!-- <div class="split_line"></div> -->
        <!-- <div class="public_text toverflow flex-1" v-html="lastNotice.noticeContent"></div> -->
      </div>
      <div class="public_text">{{ lastNotice.createTime?.split(" ")[0] }}</div>
    </div>
    <div class="btn_reliease mar_top_20 mar_bottom_20 cursor_pointer" @click="releasePublic(true)">
      发布主题
    </div>
    <div class="top_title mar_top_10 flex Flexalign FlexBetween" v-if="listQuery.classify == ''">
      <div>子版块</div>
    </div>
    <div class="sub_section_box flex Flexalign FlexBetween cursor_pointer" v-if="listQuery.classify == ''"
      @click="changeClassify(1)">
      <div class="flex Flexalign mar_top_20">
        <el-image class="teacher_answer" :src="iconPath('teacher_answer.png')"></el-image>
        <div class="flex flexcolumn FlexBetween mar_left_10 sub_section_left">
          <div class="teacher_answer_text">老师答疑区</div>
          <div class="teacher_answer_attention">
            发表关于作业、测试、课件内容希望能够得到老师回答的疑问。
          </div>
        </div>
      </div>
      <!-- <div class="public_text">2024/11/04</div> -->
    </div>
    <div class="sub_section_box flex Flexalign FlexBetween cursor_pointer" v-if="listQuery.classify == ''"
      @click="changeClassify(2)">
      <div class="flex Flexalign mar_top_20">
        <el-image class="teacher_answer" :src="iconPath('classroomCommunication.png')"></el-image>
        <div class="flex flexcolumn FlexBetween mar_left_10 sub_section_left">
          <div class="teacher_answer_text">课堂交流区</div>
          <div class="teacher_answer_attention">
            这里呈现的是在课件中作为教学内容的讨论。
          </div>
        </div>
      </div>
      <!-- <div class="public_text">2024/11/04</div> -->
    </div>
    <div class="sub_section_box flex Flexalign FlexBetween cursor_pointer" v-if="listQuery.classify == ''"
      @click="changeClassify(3)">
      <div class="flex Flexalign mar_top_20">
        <el-image class="teacher_answer" :src="iconPath('comprehensiveDiscussion.png')"></el-image>
        <div class="flex flexcolumn FlexBetween mar_left_10 sub_section_left">
          <div class="teacher_answer_text">综合讨论区</div>
          <div class="teacher_answer_attention">
            发表任何想与大家分享的经验及想法！关于本课程、学习、工作、生活等一般性话题。
          </div>
        </div>
      </div>
      <!-- <div class="public_text">2024/11/04</div> -->
    </div>
    <div class="top_title mar_top_30 flex Flexalign FlexBetween">
      <div>全部主题</div>
      <div class="Flexalign flex">
        <div class="Flexalign flex mar_left_20" v-for="(item, index) in sortList" :key="index">
          <div class="sort_label cursor_pointer" @click="changeSort(item)">
            {{ item.label }}
          </div>
          <div class="flex flexcolumn mar_left_10">
            <el-image class="sort_gray_icon" :src="iconPath('sort_gray_icon.png')"
              v-if="item.isUp == false && item.isDown == false"></el-image>
            <el-image class="sort_gray_icon" :src="iconPath('sort_gray_icon.png')"
              v-if="item.isUp == false && item.isDown == true"></el-image>
            <el-image class="sort_gray_icon rotage_180" :src="iconPath('sort_green_icon.png')"
              v-if="item.isUp == true && item.isDown == false"></el-image>
            <el-image class="sort_gray_icon sort_green_icon rotage_180" :src="iconPath('sort_gray_icon.png')"
              v-if="item.isUp == false && item.isDown == false"></el-image>
            <el-image class="sort_gray_icon sort_green_icon rotage_180" :src="iconPath('sort_gray_icon.png')"
              v-if="item.isUp == true && item.isDown == false"></el-image>
            <el-image class="sort_gray_icon sort_green_icon" :src="iconPath('sort_green_icon.png')"
              v-if="item.isUp == false && item.isDown == true"></el-image>
          </div>
        </div>
      </div>
    </div>
    <div class="evaluate_list mar_top_10" v-if="listTotal">
      <div class="evaluate_one flex" v-for="(item, index) in evaluateList" :key="index">
        <div class="flex" style="width: 100%;"
          v-if="(item.auditStatus == 2) || (userInfo.buyerUserId == item.buyerUserId)">
          <div class="evaluate_one_left">
            <el-image class="avatar" :src="imgPath(item.buyerUserHeadImage)"></el-image>
          </div>
          <div class="evaluate_one_right flex-1">
            <div class="flex Flexalign evaluate_name">
              <div>{{ item.buyerUserName }}</div>
              <!-- <div class="evaluate_rate">
              <el-image class="member_logo" :src="iconPath('member_logo.png')"></el-image>
            </div> -->
            </div>
            <div class="evaluate_content flex FlexBaseline">
              <el-image class="question_icon" :src="iconPath('question_icon.png')"></el-image>
              <!-- {{ item.content.split("url:")[0] }} -->
              <div class="flex-1" v-html="getContent(item.content)"></div>
            </div>
            <div class="question_img flex Flexalign" v-if="item.questionImg">
                <el-image class="questionImg mr-15 mt-15"
                  v-for="(img, imgIndex) in item.questionImg" :src="imgPath(img)" :key="imgIndex"
                  :preview-src-list="[img]"></el-image>
              </div>
            <div class="evaluate_time flex Flexalign FlexBetween">
              <div>
                {{ item.createTime
                }}{{ item.auditStatus == 1 ? "·内容审核中 仅自己可见" : (item.auditStatus == 3 ? '审核不通过' : '') }}
              </div>
              <div class="reply_box flex Flexalign">
                <div class="flex Flexalign cursor_pointer" @click="addReply(item.discussId, 2)">
                  <el-image class="reply_img" :src="imgPath('reply_icon.png')"></el-image>
                  <div class="reply_text">回复</div>
                </div>
                <div class="split_line"></div>
                <el-image class="reply_img cursor_pointer" :src="imgPath('like_icon.png')" v-show="!item.isLiked"
                  @click="evaluateLike(item.discussId, index)"></el-image>
                <el-image class="reply_img cursor_pointer" :src="imgPath('liked_icon.png')" v-show="item.isLiked"
                  @click="evaluateLike(item.discussId, index)"></el-image>
                <div class="reply_text">{{ item.likeNum }}</div>
              </div>
            </div>
            <div class="" v-if="item.subEvaluateList.length">
              <div class="subEvaluate_box" :class="{ expanded: isExpanded }" ref="subEvaluate">
                <div class="subEvaluate_one" v-for="(sitem, sindex) in item.subEvaluateList" :key="sindex">
                  <div class="flex Flexalign evaluate_name reply_info">
                    <el-image class="avatar" :src="imgPath(sitem.buyerUserHeadImage)"></el-image>
                    <div class="replyer_name">{{ sitem.buyerUserName }}</div>
                    <el-image class="omment_icon" :src="iconPath('omment_icon.png')" v-if="sitem.isComment"></el-image>
                    <div class="reply_text">回复</div>
                    <div class="replyer_name">{{ sitem.targetBuyerUserName }}:</div>
                  </div>
                  <div class="evaluate_content reply_evaluate_content">
                    {{ sitem.content }}
                  </div>
                  <div class="evaluate_time reply_evaluate_time flex Flexalign FlexBetween">
                    <div>{{ sitem.createTime }}</div>
                    <div class="reply_box flex Flexalign">
                      <el-image class="reply_img" :src="imgPath('reply_icon.png')"></el-image>
                      <div class="reply_text cursor_pointer" @click="addReply(sitem.replyId, 3)">
                        回复
                      </div>
                      <div class="split_line"></div>
                      <el-image class="reply_img cursor_pointer" :src="imgPath('like_icon.png')" v-if="!sitem.isLiked"
                        @click="evaluateReplyLike(sitem.replyId, index, sindex)"></el-image>
                      <el-image class="reply_img cursor_pointer" :src="imgPath('liked_icon.png')"
                        @click="evaluateReplyLike(sitem.replyId, index, sindex)" v-else></el-image>
                      <div class="reply_text">{{ sitem.likeNum }}</div>
                    </div>
                  </div>
                </div>
                <div v-if="groupPageSize <= item.subEvaluateList?.length">
                  <div class="mar_top_10 flex Flexalign cursor_pointer" @click="getMoreSubEvaluate(item)" v-if="
                    item.subEvaluateList[0].totalNum != item.subEvaluateList?.length
                  ">
                    查看剩余回复
                    <el-icon>
                      <ArrowDown />
                    </el-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="more_load flex Flexalign Flexjustify" v-if="showLoadMore" @click="toggleExpand">
        {{ isExpanded ? "收起" : "加载更多" }}
        <el-icon v-if="!isExpanded">
          <ArrowDown />
        </el-icon>
        <el-icon v-else>
          <ArrowUp />
        </el-icon>
      </div>
      <div class="pagination_box mar_top_10 flex FlexjustifyEnd">
        <el-pagination background layout="prev, pager, next" :total="listTotal" @current-change="handleCurrentChange" />
      </div>
    </div>
    <div class="evaluate_list mar_top_10" v-else>
      <moe-empty :url="'moe_empty_bg_img.png'" :emptyText="emptyText"></moe-empty>
    </div>
  </div>
  <releasePublic v-if="showReleasePublic" :courseId="courseDetail.courseId" @releasePublicChange="releasePublic">
  </releasePublic>
  <evaluateReply ref="evaluateReply" @refreshGetList="getDiscussList"></evaluateReply>
</template>

<script>
import evaluateReply from "@/components/popup/evaluateReply.vue";
import releasePublic from "./releasePublic.vue";
import { mapState } from "vuex";
export default {
  name: "GjkcH5Discussion",
  components: {
    releasePublic,
    evaluateReply,
  },
  props: {
    courseDetail: {},
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  data() {
    return {
      sortList: [
        { label: "发布时间", isUp: false, isDown: false, field: "create_time" },
        { label: "回复数", isUp: false, isDown: false, field: "reply_num" },
        { label: "点赞数", isUp: false, isDown: false, field: "like_num" },
      ],
      evaluateList: [],
      isExpanded: false,
      showLoadMore: false,
      showReleasePublic: false,
      listQuery: {
        page: 1,
        pageSize: 10,
        courseId: "",
        classify: "", //1=老师答疑区，2=课堂交流区，3=综合讨论区
        orderByColumn: "",
        isAsc: "",
      },
      listTotal: "",
      groupPageSize: 3,
      emptyText: "暂无主题",
      courseNoticeParams: {
        page: 1,
        pageSize: 10,
        courseId: "",
      },
      lastNotice: {},
      useRule: "",
      showUseRuleFlag: false,
      imgList: [],
    };
  },
  watch: {
    items: {
      immediate: true,
      handler() {
        this.$nextTick(this.checkOverflow);
      },
    },
    courseDetail: {
      handler(value) {
        if (value) {
          this.getDiscussList();
          this.getCourseNoticeList();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.getUseRule();
  },

  methods: {
    getContent(content) {
      // 判断是否富文本
      const regex = /<(p|div|span|b|i|u|strong|em|img|ul|li|br)\b[^>]*>/i;
      let flag = regex.test(content);
      if (flag) {
        return content
      } else {
        return content.split("url:")[0]
      }
    },
    goNoticeDetail(info) {
      this.href("/noticeDetail", { noticeId: info.noticeId });
    },
    getUseRule() {
      this.$Api.login
        .getAgreement("course_discuss_publish_user_rules")
        .then((res) => {
          this.useRule = res.data.data?.content;
        })
        .catch(() => { });
    },
    showUseRule() {
      this.showUseRuleFlag = true;
    },
    hideUseRule() {
      this.showUseRuleFlag = false;
    },
    // 公告列表
    getCourseNoticeList() {
      this.courseNoticeParams.courseId = this.courseDetail.courseId;
      this.$Api.course
        .getCourseNoticeList(this.courseNoticeParams)
        .then((res) => {
          if (res.data.data) {
            this.lastNotice = res.data.data.list[0];
            // 将富文本p标签替换成span标签做溢出...效果
            // this.lastNotice.noticeContent = this.lastNotice.noticeContent.replaceAll("<p","<span")
          }
        })
        .catch(() => { });
    },
    // 排序
    changeSort(info) {
      // 恢复默认排序
      this.sortList.forEach((item) => {
        if (item.label != info.label) {
          item.isDown = false;
          item.isUp = false;
        }
      });
      if (!info.isDown && !info.isUp) {
        info.isUp = true;
      } else {
        info.isUp = !info.isUp;
        info.isDown = !info.isDown;
      }
      this.getDiscussList();
    },
    // 选择类型
    changeClassify(type) {
      this.listQuery.classify = type;
      this.getDiscussList();
    },
    // 分页
    handleCurrentChange(value) {
      this.listQuery.page = value;
      this.getDiscussList();
    },
    // 获取答疑区列表
    getDiscussList() {
      this.listQuery.courseId = this.courseDetail.courseId;
      this.listQuery.orderByColumn = "";
      this.listQuery.isAsc = "";
      // 处理升降序
      this.sortList.forEach((item) => {
        if (item.isUp || item.isDown) {
          this.listQuery.orderByColumn = item.field;
          this.listQuery.isAsc = item.isUp ? "asc" : "desc";
        }
      });
      this.$Api.course
        .getDiscussList(this.listQuery)
        .then((res) => {
          this.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
          let list = res.data.data.list;
          for (const item of list) {
            // item.score = this.$Tools.scoreToStar(item.score);
            item.isLiked = false;
            item.isFirstLoad = true; // 用于判断加载回复接口（为true则将初始的subEvaluateList置空，采用分页的接口获取数据填充，每点击一次页码+1）
            item.pageSize = 10; // 用于查询回复接口（分页）
            item.page = 1;
            item.subEvaluateList = [];
            // let questionImg = item.content.split("url:");
            // if (questionImg.length > 1) {
            //   item.questionImg = questionImg[1].split(";");
            //   let length = item?.questionImg.length;
            //   if (item.questionImg[length - 1] == "") {
            //     item.questionImg.pop();
            //   }
            // }
            // 修改了逻辑，之前在视频下发表主题是通过拼接的方式实现图文，现换成imgs和content，此处处理是为了兼容之前发布的主题
            if (this.$Tools.empty(item.imgs)) {
              let questionImg = item.content.split("url:");
              if (questionImg.length > 1) {
                item.questionImg = questionImg[1].split(";");
                let length = item?.questionImg.length;
                if (item.questionImg[length - 1] == "") {
                  item.questionImg.pop();
                }
              }
            } else {
              item.questionImg = item.imgs.split(",");
            }
          }
          this.evaluateList = list;
          this.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
          this.checkIsLike(); // 评价是否点赞
          this.getReplyListBySize(); // 获取评价下的回复
          this.checkReplyIsLike(); // 回复是否点赞
          setTimeout(() => {
            this.checkOverflow();
          }, 500);
        })
        .catch((err) => {
          // this.$Dialog.toast(err.message, { type: "error" });
          console.log(err);
        });
    },
    // 获取回复信息
    async getReplyListBySize() {
      let listQuery = {
        courseId: this.courseDetail.courseId,
        scene: 2,
        sceneIds: "",
        groupPageSize: this.groupPageSize,
      };
      // 参数合集，查所有评价列表的回复
      this.evaluateList.forEach((item) => {
        listQuery.sceneIds += item.discussId + ",";
      });
      this.$Api.course
        .getReplyListBySize(listQuery)
        .then((res) => {
          // 遍历出对应评价的回复
          res.data.data.forEach((item) => {
            let findIndex = this.evaluateList.findIndex(
              (sitem) => sitem.discussId == item.sceneId
            );
            if (findIndex != -1) {
              this.evaluateList[findIndex].subEvaluateList.push(item);
            }
          });
        })
        .catch((err) => {
          // this.$Dialog.toast(err.message, { type: "error" });
          console.log(err);
        });
    },
    // 判断是否点赞（评价）
    checkIsLike() {
      let listQuery = {
        courseId: this.courseDetail.courseId,
        scene: 2,
        sceneIds: "",
      };
      this.evaluateList.forEach((item) => {
        listQuery.sceneIds += item.discussId + ",";
      });
      if (!listQuery.sceneIds) return;
      this.$Api.course
        .checkIsLike(listQuery)
        .then((res) => {
          this.evaluateList.forEach((item) => {
            let currentIndex = res.data.data.findIndex(
              (sitem) => sitem == item.discussId
            );
            if (currentIndex != -1) item.isLiked = true;
          });
        })
        .catch((err) => {
          // this.$Dialog.toast(err.message, { type: "error" });
          console.log(err);
        });
    },
    // 判断是否点赞（评价回复）
    checkReplyIsLike() {
      let listQuery = {
        courseId: this.courseDetail.courseId,
        scene: 3,
        sceneIds: "",
      };
      this.evaluateList.forEach((item) => {
        item.subEvaluateList.forEach((sitem) => {
          listQuery.sceneIds += sitem.replyId + ",";
        });
      });
      if (!listQuery.sceneIds) return;
      this.$Api.course.checkIsLike(listQuery).then((res) => {
        this.evaluateList.forEach((item) => {
          item.subEvaluateList.forEach((sitem) => {
            let currentIndex = res.data.data.findIndex(
              (ssitem) => ssitem == sitem.replyId
            );
            if (currentIndex != -1) sitem.isLiked = true;
          });
        });
      });
    },
    // 评价点赞
    evaluateLike(id, index) {
      let query = {
        courseId: this.courseDetail.courseId,
        scene: 2, // 1=评价 2=讨论组 3=回复
        sceneId: id, //评价ID、讨论组主题ID、回复ID
      };
      this.$Api.course
        .evaluateLike(query)
        .then((res) => {
          console.log(res);
          if (this.evaluateList[index].isLiked) {
            this.evaluateList[index].likeNum--;
          } else {
            this.evaluateList[index].likeNum++;
          }
          this.evaluateList[index].isLiked = !this.evaluateList[index].isLiked;
          // this.evaluateList = [];
          // this.getEvaluateList();
        })
        .catch((err) => {
          // this.$Dialog.toast(err.message, { type: "error" });
          console.log(err);
        });
    },
    // 评价回复点赞
    evaluateReplyLike(id, index, sindex) {
      let query = {
        courseId: this.courseDetail.courseId,
        scene: 3, // 1=评价 2=讨论组 3=回复
        sceneId: id, //评价ID、讨论组主题ID、回复ID
      };
      this.$Api.course
        .evaluateLike(query)
        .then((res) => {
          console.log(res);
          if (this.evaluateList[index].subEvaluateList[sindex].isLiked) {
            this.evaluateList[index].subEvaluateList[sindex].likeNum--;
          } else {
            this.evaluateList[index].subEvaluateList[sindex].likeNum++;
          }
          this.evaluateList[index].subEvaluateList[sindex].isLiked = !this.evaluateList[
            index
          ].subEvaluateList[sindex].isLiked;
          // this.evaluateList = [];
          // this.getEvaluateList();
        })
        .catch((err) => {
          // this.$Dialog.toast(err.message, { type: "error" });
          console.log(err);
        });
    },
    // 查看更多回复
    getMoreSubEvaluate(info) {
      if (!info.isFirstLoad) {
        ++info.page;
      }
      let listQuery = {
        page: info.page,
        pageSize: info.pageSize,
        courseId: this.courseDetail.courseId,
        scene: 2, // 场景：1评价，2讨论组
        sceneId: info.discussId,
        lteCreateTime: info.subEvaluateList[0].createTime,
      };
      this.$Api.course
        .getReplyList(listQuery)
        .then((res) => {
          // 第一次查询回复列表限制了条数，后面每次点击查询更多调用分页接口查询
          if (info.isFirstLoad) {
            info.subEvaluateList = res.data.data.list;
            info.isFirstLoad = false;
          } else {
            info.subEvaluateList = [...info.subEvaluateList, ...res.data.data.list];
          }
          // 加个字段用于判断当前回复数是否已加载完（用于是否展示加载剩余回复字样）
          info.subEvaluateList.forEach((item) => {
            item.totalNum = res.data.data.total;
          });
          this.checkReplyIsLike(); // 回复是否点赞
        })
        .catch((err) => {
          // this.$Dialog.toast(err.message, { type: "error" });
          console.log(err);
        });
    },
    // 回复评价
    addReply(sceneId, scene) {
      this.$refs.evaluateReply.learningEvaluateShow = true;
      this.$refs.evaluateReply.evaluateInfo.sceneId = sceneId;
      this.$refs.evaluateReply.evaluateInfo.scene = scene;
    },
    releasePublic(flag) {
      this.showReleasePublic = flag;
      // 刷新列表
      this.getDiscussList();
    },
    checkOverflow() {
      if (!this.$refs.subEvaluate) return;
      this.showLoadMore =
        this.$refs.subEvaluate.scrollHeight > this.$refs.subEvaluate.clientHeight;
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>

<style lang="scss" scoped>
.discussion_box {
  width: 762px;
  padding: 15px 20px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 10px;
  margin-bottom: 30px;

  .top_title {
    font-weight: bold;
    font-size: 18px;
    color: #111111;
    padding-bottom: 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #dedede;

    .use_rule {
      font-weight: normal;
      font-size: 14px;
      color: #13d6aa;
      position: relative;

      .use_rule_box {
        z-index: 9;
        position: absolute;
        top: 24px;
        // left: -180px;
        right: 0;
        width: 231px;
        // height: 166px;
        padding: 15px 10px;
        background: #ffffff;
        box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        font-size: 14px;
        color: #666666;
        line-height: 21px;
        max-height: 150px;
        overflow: auto;

        .use_rule_title {
          color: #111111;
          line-height: 21px;
        }
      }

      .green_doubt_icon {
        width: 18px;
        height: 18px;
      }
    }

    .sort_label {
      color: #666666;
      font-weight: normal;
      font-size: 16px;
    }

    .sort_gray_icon {
      width: 10px;
      height: 6px;
    }

    .rotage_180 {
      transform: rotate(180deg);
    }

    .sort_green_icon {
      margin-top: 5px;
    }
  }

  .discussion_welcome {
    color: #666666;
  }

  .notice_box {
    width: 722px;
    height: 54px;
    background: rgba(245, 246, 248, 0.8);
    border-radius: 10px;
    padding: 10px 15px;
    box-sizing: border-box;

    .teacher_public {
      width: 36px;
      height: 36px;
    }

    .teacher_public_text {
      color: #333333;
      font-weight: 600;
    }

    .split_line {
      width: 1px;
      height: 24px;
      background: #dedede;
      margin: 0 15px;
    }
  }

  .public_text {
    color: #999999;
  }

  .btn_reliease {
    width: 118px;
    height: 36px;
    background: linear-gradient(90deg, #00d5c2, #00d498);
    border-radius: 18px;
    line-height: 36px;
    text-align: center;
    color: #ffffff;
  }

  .sub_section_box {
    .sub_section_left {
      height: 46px;
    }

    .teacher_answer {
      width: 46px;
      height: 46px;
    }

    .teacher_answer_text {
      font-size: 18px;
      color: #333333;
      // font-weight: 600;
    }

    .teacher_answer_attention {
      font-size: 14px;
      color: #999999;
    }
  }

  .evaluate_list {
    width: 100%;
    overflow: hidden;

    .evaluate_one {
      margin-top: 10px;

      .evaluate_one_left {
        .avatar {
          width: 48px;
          height: 48px;
          border-radius: 50%;
        }
      }

      .evaluate_one_right {
        margin-left: 13px;
        color: rgba(153, 153, 153, 1);

        .evaluate_rate {
          .member_logo {
            width: 72px;
            height: 28px;
          }

          // width: 72px;
          // height: 28px;
          // background: linear-gradient(90deg, #DEB879, #F3DFB7);
          // border-radius: 6px;
          margin-left: 13px;
        }

        .evaluate_content {
          margin-top: 5px;
          // font-weight: 600;
          color: #333333;

          .question_icon {
            margin-right: 7px;
            width: 26px;
            height: 17px;
          }
        }

        .question_img {
            // margin-top: 15px;
            margin-left: 30px;
            flex-wrap: wrap;

            .questionImg {
              width: 130px;
              height: 130px;
              border-radius: 10px;
              // width: 241px;
              // height: 148px;
            }
          }

        .evaluate_time {
          width: 100%;
          color: #999999;
          margin-top: 15px;

          .reply_box {
            .reply_img {
              width: 24px;
              height: 24px;
            }

            .split_line {
              margin: 0 12px;
              width: 1px;
              height: 20px;
              background: #141414;
              opacity: 0.1;
            }

            .reply_text {
              margin-left: 6px;
            }
          }
        }

        .subEvaluate_box {
          // max-height: 200px;
          overflow: hidden;
        }

        .expanded {
          max-height: none;
          overflow: visible;
        }

        .reply_info {
          margin-top: 10px;

          .avatar {
            width: 24px;
            height: 24px;
            border-radius: 50%;
          }

          .replyer_name {
            margin-left: 8px;
          }

          .omment_icon {
            margin-left: 8px;
            width: 46px;
            height: 17px;
          }

          .reply_text {
            margin-left: 10px;
            color: #333333;
            // font-weight: 600;
          }
        }

        .reply_evaluate_content {
          margin-top: 10px;
        }

        .reply_evaluate_time {
          margin-top: 10px;
        }
      }
    }
  }

  .course_introduce_content.expanded {
    max-height: none;
    overflow: visible;
    /* 展开后高度 */
  }

  .more_load {
    width: 100%;
    height: 50px;
    background: #ffffff;
    border-radius: 0px 0px 20px 20px;
    // position: absolute;
    // bottom: 0;
    z-index: 9;
    color: #999999;
  }
}
</style>
